import React from "react";
import MetaTags from "@/components/seo/meta-tags";
import FeatureImageWithBlur from "@/components/us-website/FeatureImageWithBlur/FeatureImageWithBlur";
import TailSpendHiddenCosts from "@/components/us-website/TailSpendManagement/TailSpendHiddenCosts";
import TailSpendApproach from "@/components/us-website/TailSpendManagement/TailSpendApproach";
import TailSpendWhyPartner from "@/components/us-website/TailSpendManagement/TailSpendWhyPartner";
import TailSpendAdvantage from "@/components/us-website/TailSpendManagement/TailSpendAdvantage";
import FAQSection from "@/components/us-website/FAQSection/FAQSection";
import ContactUsForm from "@/components/us-website/ContactUsForm/ContactUsForm";
import { getCDNImageUrl, WHATSAPP_CONTACT_LINK } from "@/utils/Common";
import { TAIL_SPEND_FAQ_DATA } from "@/constastants/TailSpendConstants";
import { useRouter } from "next/router";

function TailSpendManagementPage() {
  const router = useRouter();

  const handleTalkToExpert = () => {
    router.push("/contact-elchemy");
  };

  return (
    <>
      <MetaTags
        title="Tail Spend Management Solutions | Elchemy Procurement"
        description="Elchemy makes tail spend management simple. Explore tail spend analysis, expert-led strategies for managing tail spend, and cost-saving solutions"
        includeAlternateLink={true}
      />
      <div>
        {/* Hero Section */}
        <FeatureImageWithBlur
          heading="Smartly Optimising your Tail Management for Modern Procurement"
          description="Managing tail spend shouldn't drain your team's resources. Elchemy's platform brings visibility, automation, and control to every corner of your procurement spend - no matter how small the transaction."
          imageSrc={getCDNImageUrl("tail-spend-hero1.webp")}
          variant="dark"
          showPrimaryButton={true}
          primaryButtonText="Talk to an Expert"
          onClickPrimaryButton={handleTalkToExpert}
        />

        {/* The Hidden Cost of Tail Spend */}
        <TailSpendHiddenCosts />

        {/* Two Ways We Approach Tail Spend */}
        <TailSpendApproach />

        {/* Why Partner With Us */}
        <TailSpendWhyPartner />

        {/* The Elchemy Advantage */}
        <TailSpendAdvantage />

        {/* FAQ Section */}
        <FAQSection
          faqs={TAIL_SPEND_FAQ_DATA}
          industryName="Tail Spend"
          description="Everything procurement and supply chain teams need to know about managing tail spend with Elchemy - from tail spend analysis to JIT delivery and compliance."
          hideContactCard={true}
          backgroundColor="transparent"
        />

        {/* Contact Form */}
        <ContactUsForm />
      </div>
    </>
  );
}

export default TailSpendManagementPage;
